
import React from "react";

import throttle from 'lodash.throttle';
import { EVENT_HANDLER_THROTTLE_TIME } from "../../../Consts";
import { AgreementMaintenancePage, IAgreementMaintenancePageProps } from "./AgreementMaintenancePage";


const AgreementMaintenancePageScrollListener: React.FC<IAgreementMaintenancePageProps> = (props) => {
    const [updatedScroll, setUpdatedScroll] = React.useState(0);
    React.useEffect(() => {
        window.addEventListener(
            "scroll",
            throttle(handleScroll, EVENT_HANDLER_THROTTLE_TIME, {
                trailing: true
            })
        );
        return  window.removeEventListener(
            "scroll",
            throttle(handleScroll, EVENT_HANDLER_THROTTLE_TIME, {
                leading: true
            })
        );
    }, []);
    const handleScroll = () => {
        setUpdatedScroll(window.scrollY);
    };
    return <AgreementMaintenancePage {...props} updatedScroll={updatedScroll} />
    
}
export default AgreementMaintenancePageScrollListener;